/*
 *   Need to have a disabled state if homeowner is not in the room - or send a SMS message - this needs to be clear
 */

import { SendRounded } from '@mui/icons-material';
import { Box, IconButton, TextField, Typography } from '@mui/material';
import dayjs from 'dayjs';
import React, { useRef, useState } from 'react';

import { useDaily } from '@daily-co/daily-react';
import { useSessionContext } from '../../contexts/SessionContext';
import { IChat } from '../../global/interfaces';
import { COLORS } from '../../utils/colors';
import { generateRandomId, scrollToBottom } from '../../utils/helpers';
import { StyledSideTab, StyledSideTabs } from '../StyledTabs';
import { useChatStyles } from './styles';
import { useBookingsContext } from '../../contexts/BookingsContext';

interface chatProps {
  useTabs: boolean;
  viewTitle: string;
}

const Chat = ({ viewTitle, useTabs }: chatProps) => {
  const { localParticipantId, chatHistory, setChatHistory } =
    useSessionContext();
  const styles = useChatStyles();
  const [inputValue, setInputValue] = useState('');
  const { context } = useBookingsContext();
  const [hasContext, setHasContext] = useState<boolean>(!!context);

  const scrollableElRef = useRef<any>();

  const callObject = useDaily();
  const [value, setValue] = useState(0);

  const handleChange = (newValue: number) => {
    setValue(newValue);
  };

  const handleSendMessage = () => {
    const payload = {
      id: generateRandomId(),
      type: 'chat',
      message: inputValue,
      senderId: localParticipantId,
      date: new Date(),
    };

    console.log(`++++send message: ${JSON.stringify(payload, null, 3)}`);

    callObject?.sendAppMessage(payload, '*');
    setChatHistory([...chatHistory, payload]);
    setInputValue('');
    scrollToBottom(scrollableElRef);
  };

  return (
    <>
      <StyledSideTabs value={value} onChange={() => handleChange}>
        <StyledSideTab value={value} label={viewTitle} />
      </StyledSideTabs>
      {value === 0 && (
        <Box>
          <Box ref={scrollableElRef} sx={styles.chatPanel}>
            {chatHistory?.map(
              ({ date, id, message, senderId }: IChat, index: number) => {
                return (
                  <Box key={index}>
                    {senderId === localParticipantId ? (
                      <Box sx={styles.chatBox} mb="12px">
                        <Box
                          sx={{
                            backgroundImage:
                              'linear-gradient(to bottom right, #ff9e54, #ff6e00)',
                          }}
                          borderRadius="10px 0 10px 10px"
                          padding="12px">
                          <Typography
                            color="white"
                            fontWeight={500}
                            fontSize="13px">
                            {message}
                          </Typography>
                        </Box>
                        <Typography mt="5px" fontSize="12px" fontWeight={600}>
                          {dayjs(date).format('hh:mmA')}
                        </Typography>
                      </Box>
                    ) : (
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="flex-start"
                        mb="12px">
                        <Box
                          bgcolor={COLORS.WHITE}
                          borderRadius="0 10px 10px 10px"
                          padding="12px">
                          <Typography fontWeight={500} fontSize="13px">
                            {message}
                          </Typography>
                        </Box>
                        <Typography mt="5px" fontSize="12px" fontWeight={600}>
                          {dayjs(date).format('hh:mmA')}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                );
              },
            )}
          </Box>
          {useTabs && (
            <TextField
              sx={styles.enterMessage}
              fullWidth
              variant="standard"
              placeholder="Type a message"
              value={inputValue}
              onChange={({ target }) => setInputValue(target.value)}
              InputProps={{
                endAdornment: (
                  <IconButton onClick={handleSendMessage}>
                    <SendRounded sx={{ color: COLORS.PRIMARY }} />
                  </IconButton>
                ),
                disableUnderline: true,
              }}
            />
          )}
        </Box>
      )}
    </>
  );
};

export default Chat;
